import { IWorkOrderEvidence } from "../common/data/dtos/work-order-evidence";
import { DELETE_TYPED_ASYNC, POST_TYPED_ASYNC } from "../helpers/httpHelper";

const BASE_PATH = 'api/WorkOrderEvidence';

interface WorkOrderEvidenceResponse {
    success: boolean;
    workOrderEvidence?: IWorkOrderEvidence;
    workOrdersEvidences?: IWorkOrderEvidence[];
    error?: string;
}

type CreateWorkOrderEvidenceType = Omit<IWorkOrderEvidence, 'id'> | Partial<IWorkOrderEvidence>;

const createWorkOrderEvidence = async (formData: FormData): Promise<WorkOrderEvidenceResponse> => {
    try {
        const response = await POST_TYPED_ASYNC<IWorkOrderEvidence>(
            `${BASE_PATH}`, 
            formData
        );

        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const deleteWorkOrderEvidence = async (id: string): Promise<WorkOrderEvidenceResponse> => {
    try {
        const response = await DELETE_TYPED_ASYNC<IWorkOrderEvidence>(`${BASE_PATH}/${id}`);

        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

export default {
    createWorkOrderEvidence,
    deleteWorkOrderEvidence
};